import { useEffect } from 'react'
import { useRouter } from 'next/router'

const OptinMonsterEmbed = () => {
    const router = useRouter()

    useEffect(() => {
        // Script insertion
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.async = true
        script.src = 'https://a.omappapi.com/app/js/api.min.js'
        script.dataset.user = '299882'
        script.dataset.account = '318196'
        document.head.appendChild(script)

        // Handle route changes
        const handleRouteChange = () => {
            if (window.om299882_318196) {
                window.om299882_318196.reset()
            }
        }

        router.events.on('routeChangeComplete', handleRouteChange)

        // Cleanup on component unmount
        return () => {
            router.events.off('routeChangeComplete', handleRouteChange)
            document.head.removeChild(script)
        }
    }, [router]) // Depend on `router` to ensure the effect is correctly handled on route changes

    return null // This component does not render anything itself
}

export { OptinMonsterEmbed }
